import React from "react";
import { CheckCircle2, Clock, XCircle, Circle } from "lucide-react";

const MAP = {
  Passed: { cls: "bg-primary/10 text-primary border-primary/20", Icon: CheckCircle2, label: "Passed" },
  "In Progress": { cls: "bg-[hsl(43_60%_55%/0.15)] text-[hsl(30_70%_32%)] border-[hsl(43_60%_55%/0.3)]", Icon: Clock, label: "In Progress" },
  "Failed / Retake Required": { cls: "bg-destructive/10 text-destructive border-destructive/20", Icon: XCircle, label: "Retake Required" },
  "Not Started": { cls: "bg-muted text-muted-foreground border-border", Icon: Circle, label: "Not Started" },
};

export function StatusBadge({ status, testid }) {
  const cfg = MAP[status] || MAP["Not Started"];
  const { Icon } = cfg;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${cfg.cls}`}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={2.2} />
      {cfg.label}
    </span>
  );
}
